export enum CarType {
  ICE = "ICE",
  HYBRID = "HYBRID",
  EV = "EV",
}

export interface CarExpenses {
  interestCosts: number;
  leasingCosts: number;
  carFees: number;
  carCosts: number;
  depreciationCosts: number;
}

export interface CarUsageInputs {
  carType: CarType;
  commuteDistance: number;
  commuteDays: number;
}

export interface EuerDeclarationCarUsageSubform1PctMethodInputs
  extends CarUsageInputs {
  catalogPrice: number;
  purchaseDate: string;
  usageMonths: number;
  actualCosts: number;
  interestCosts: number;
  depreciationCosts: number;
  collectedVat?: number;
}

export interface EuerDeclarationCarUsageSubformDriversLogInputs
  extends CarUsageInputs {
  totalKm: number;
  privateKm: number;
  homeCompanyKm: number;
  carExpenses: CarExpenses;
  carExpensesWithTaxDeduction: CarExpenses;
}

export type EuerDeclarationCarUsageSubformInputs =
  | EuerDeclarationCarUsageSubform1PctMethodInputs
  | EuerDeclarationCarUsageSubformDriversLogInputs;

export interface EuerDeclarationCarUsageSubformCalculationResults {
  privateCarUsage: number; // [106] Private Kfz-Nutzung
  collectedVat: number; // [140] Vereinnahmte USt 19 %
  // `autoCalculatedCollectedVat` is only for the 1-percent method.
  autoCalculatedCollectedVat?: number; // [140] Vereinnahmte USt 19 %
  homeCompanyTrips: number; // [142] Fahrten zwischen Wohnung/Betrieb
  minDeductibleTravelExpenses: number; // [176] Min. abziehbare Fahrtkosten
  // `costCap` is only used for the 1% calculation method.
  costCap?: number; // Kostendeckelung
  profitIncrease: number; // Gewinnerhöhung
}
